export default "__VITE_ASSET__BclkoEGS__"